import React, { useState, useEffect } from "react";
import { fetchOne } from "../utils/fetchResources";
import { useParams, Prompt } from "react-router-dom";
import {
	Button,
	TextField,
	Typography,
	FormControl,
	Select,
	InputLabel,
	MenuItem,
	Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
	},
	submit: {
		margin: theme.spacing(2, 0, 1),
	},
}));

export default function UsersEdit(props) {
	const { id } = useParams();
	const classes = useStyles();
	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState();
	const [unsaved, setUnsaved] = useState(false);
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		(async () => {
			await fetchOne("users", id, setUser);
			setLoading(false);
		})();
	}, [id]);

	const onChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
		setUnsaved(true);
	};

	const onSubmit = (e) => {
		e.preventDefault();

		//Remove any keys with an empty str as the value
		for (const key of Object.keys(user)) {
			if (user[key] === "") {
				delete user[key];
			}
		}

		fetch(`${process.env.REACT_APP_API_URL}/users/${id}`, {
			method: "PUT",
			credentials: "include",
			body: JSON.stringify(user),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					setUnsaved(false);
					enqueueSnackbar("User updated successfully!", { variant: "success" });
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	if (loading) {
		return <div>Loading...</div>;
	}

	return (
		<>
			<Prompt
				when={unsaved}
				message="You have unsaved changes. Are you sure you want to leave?"
			/>
			<Typography component="h1" variant="h4">
				Edit a User: {(user && user.name) || ""}
			</Typography>
			<form className={classes.form} onSubmit={onSubmit}>
				<Grid container spacing={1}>
					<Grid item sm={6} xs={12}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="name"
							label="User Name"
							name="name"
							size="small"
							value={(user && user.name) || ""}
							required
							onChange={onChange}
						/>
					</Grid>
					<Grid item sm={6} xs={12}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							id="email"
							label="E-mail"
							name="email"
							size="small"
							value={(user && user.email) || ""}
							type="email"
							required
							onChange={onChange}
						/>
					</Grid>
				</Grid>
				<Grid container spacing={1}>
					<Grid item sm={6} xs={12}>
						<FormControl
							fullWidth
							size="small"
							margin="normal"
							variant="outlined"
							className={classes.formControl}
							required
							name="role"
						>
							<InputLabel id="user-role-label">Role</InputLabel>
							<Select
								inputProps={{ name: "role" }}
								value={(user && user.role) || ""}
								onChange={onChange}
								label="role"
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value="editor">Editor</MenuItem>
								<MenuItem value="admin">Admin</MenuItem>
							</Select>
						</FormControl>
					</Grid>
					<Grid item sm={6} xs={12}>
						<FormControl
							fullWidth
							size="small"
							margin="normal"
							variant="outlined"
							className={classes.formControl}
							required
							name="active"
						>
							<InputLabel id="user-role-label">Active</InputLabel>
							<Select
								inputProps={{ name: "active" }}
								value={(user && user.active) || false}
								onChange={onChange}
								label="active"
							>
								<MenuItem value={true}>True</MenuItem>
								<MenuItem value={false}>False</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid>
				<Button
					type="submit"
					fullWidth
					variant="contained"
					color="primary"
					className={classes.submit}
				>
					Save
				</Button>
			</form>
		</>
	);
}
